/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_MalayInputs */

const en_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malay`)
};

const fr_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malais`)
};

const de_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`malaiisch`)
};

const it_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`malese`)
};

const ru_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`малайский`)
};

const es_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`malayo`)
};

const zh_cn2_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`马来语`)
};

const ja_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マレー語`)
};

const hi_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मलायी`)
};

const pt_pt2_speechmatics_target_language_malay = /** @type {(inputs: Speechmatics_Target_Language_MalayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`malaio`)
};

/**
* | output |
* | --- |
* | "Malay" |
*
* @param {Speechmatics_Target_Language_MalayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_malay = /** @type {((inputs?: Speechmatics_Target_Language_MalayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_MalayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_malay(inputs)
	if (locale === "de") return de_speechmatics_target_language_malay(inputs)
	if (locale === "it") return it_speechmatics_target_language_malay(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_malay(inputs)
	if (locale === "es") return es_speechmatics_target_language_malay(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_malay(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_malay(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_malay(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_malay(inputs)
	return en_speechmatics_target_language_malay(inputs)
});